import { render, staticRenderFns } from "./sidebar-item.vue?vue&type=template&id=6620a344&scoped=true"
import script from "./sidebar-item.vue?vue&type=script&lang=js"
export * from "./sidebar-item.vue?vue&type=script&lang=js"
import style0 from "./sidebar-item.vue?vue&type=style&index=0&id=6620a344&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6620a344",
  null
  
)

export default component.exports